(function () {
  const STOREFRONT_TOKEN = '079400f9a29419f698ea3ce0a9341b7e';
  const API_VERSION = '2026-04';

  async function fetchStoreAvailability(shopDomain, variantId) {
    const variantGid = `gid://shopify/ProductVariant/${variantId}`;

    const query = `
      query getVariantAvailability($id: ID!) {
        node(id: $id) {
          ... on ProductVariant {
            id
            storeAvailability(first: 20) {
              nodes {
                available
                quantityAvailable
                pickUpTime
                location {
                  name
                  address {
                    address1
                    address2
                    city
                  }
                }
              }
            }
          }
        }
      }
    `;

    const response = await fetch(`https://${shopDomain}/api/${API_VERSION}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query,
        variables: { id: variantGid }
      })
    });

    const json = await response.json();

    if (!response.ok) {
      console.error('Storefront HTTP error:', response.status, json);
      throw new Error(`Storefront API error: ${response.status}`);
    }

    if (json.errors) {
      console.error('GraphQL errors:', json.errors);
      throw new Error('GraphQL returned errors');
    }

    return json?.data?.node?.storeAvailability?.nodes || [];
  }

  function buildHtml(container, locations) {
    const texts = {
      title: container.dataset.widgetTitle,
      herzstueck: container.dataset.widgetInfoHerzstueck,
      onlyOnline: container.dataset.onlyOnline
    };

    if (!locations.length) {
      return '';
    }

    const lines = locations.map((item) => {
      const location = item.location || {};
      const source = location.name || '';
      const address1 = location.address?.address1 || '';
      const address2 = location.address?.address2 || '';
      const city = location.address?.city || '';

      if (source.includes(' to ')) {
        const destination = source.split(' to ');
        return `${texts.onlyOnline} ${destination[1].trim()}.`;
      }

      if (source === 'Herzstück') {
        return `
          ${texts.herzstueck}<br>
          <b>${source}</b>, ${address1} ${address2}, ${city}
        `;
      }

      return `<b>${source}</b>, ${address1} ${address2}, ${city}`;
    }).join('<br>');

    return `
      <div class="product_block" style="border: 1px solid var(--colorBorder); padding: 10px; margin: 10px 0; text-align: left;">
        <b style="font-size: .8em;">${texts.title}:<br></b>
        ${lines}
      </div>
    `;
  }

  async function renderAvailability(container, variantId) {
    if (!container || !variantId) return;

    try {
      const shopDomain = container.dataset.shopDomain;
      const availabilities = await fetchStoreAvailability(shopDomain, variantId);

      const filtered = availabilities.filter((item) => {
        return item.available && item.quantityAvailable > 0;
      });

      container.innerHTML = buildHtml(container, filtered);
    } catch (error) {
      console.error('REAWAKE pickup availability error:', error);
      container.innerHTML = '';
    }
  }

  function initStaticContainers() {
    const containers = document.querySelectorAll('.reawake-store-availability');

    containers.forEach((container) => {
      const initialVariantId = container.dataset.variantId;
      renderAvailability(container, initialVariantId);
    });
  }

  document.addEventListener('DOMContentLoaded', initStaticContainers);
  document.addEventListener('page:loaded', initStaticContainers);

  document.addEventListener('variant:change', function (evt) {
    const variant = evt.detail?.variant;
    if (!variant?.id) return;

    const container = document.querySelector('.reawake-store-availability');
    if (!container) return;

    container.dataset.variantId = variant.id;
    renderAvailability(container, variant.id);
  });

  document.addEventListener('quickview:loaded', function () {
    initStaticContainers();
  });
})();